import React from 'react';
import { render } from '@testing-library/react';
import { TabGroup } from './TabGroup';
import { Tab } from '../Tab';

describe('TabGroup', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<TabGroup
				dark={false}
				divider
				fitted={false}
				verticallyDivided={false}
				size="normal"
				type="underline"
				textAlign="center"
			>
				<Tab data-auto-sel="automation-selector">First</Tab>
				<Tab>Second Tab</Tab>
				<Tab>Third Tab</Tab>
				<Tab>Fourth Tab</Tab>
			</TabGroup>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
